import { TReason, TReasonOption } from './types'

export const FORM_FIELDS = {
  ARTIST_ID: 'artist_id',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  EMAIL: 'email',
  REASON: 'reason',
  DESCRIPTION: 'description',
  SCREENSHOT: 'screenshot',
  ARTWORK_TITLE: 'artwork_title',
  ORDER_CONFIRMATION_REFERENCE: 'order_confirmation_reference',
  PHONE_NUMBER: 'phone_number',
}

export const ERROR_MESSAGES = {
  REASON_REQUIRED: 'Please select a reason',
  FIELD_REQUIRED: 'This field is required',
  SCREENSHOT_REQUIRED: 'A screenshot is required for technical issues',
}

const REASON: Record<string, TReason> = {
  TECHNICAL: 'technical',
  ORDER: 'order',
  PAYOUT: 'payout',
  UNBAN: 'unban',
}

export const reasonOptions: TReasonOption[] = [
  { value: REASON.TECHNICAL, label: 'Report technical issue' },
  { value: REASON.ORDER, label: 'Order issue' },
  { value: REASON.PAYOUT, label: 'Payout issue' },
  { value: REASON.UNBAN, label: 'Unban my account' },
]

export const getReasonFlags = (reason: TReason) => ({
  isOrderOrPayout: reason === REASON.ORDER || reason === REASON.PAYOUT,
  isTechnical: reason === REASON.TECHNICAL,
})
